import closeIcon from "@/assets/img/icon-close-black.svg";
import { Component, Prop, Vue } from "vue-property-decorator";
import { RawLocation } from "vue-router/types/router";
import * as tsx from "vue-tsx-support";
import styles from "./WizardStep.component.module.scss";

const closeIconSrc = closeIcon;

@Component
export default class WizardStep extends Vue {
  _tsx!: tsx.DeclareProps<{
    showCloseButton?: WizardStep["showCloseButton"];
    toLocationOnClose?: WizardStep["toLocationOnClose"];
  }>;

  @Prop({ required: false, default: true }) showCloseButton: boolean;
  @Prop({ required: false, default: { name: "home" } })
  toLocationOnClose: RawLocation;

  private handleClick() {
    this.$router.push(this.toLocationOnClose).catch(() => {
      /* Ignore */
    });
  }

  render() {
    return (
      <div class={styles.container}>
        <div class={styles.wizardName}>
          {this.showCloseButton && (
            <button
              class={styles.closeIconButton}
              role="button"
              onClick={this.handleClick}
            >
              <img
                class={styles.closeButtonIcon}
                src={closeIconSrc}
                alt="Close"
              />
            </button>
          )}
          <span class={styles.wizardNameText}>{this.$slots.wizardName}</span>
        </div>
        <h1 class={styles.header}>{this.$slots.header}</h1>
        <p class={styles.description}>{this.$slots.description}</p>
        <div class={styles.content}>{this.$slots.default}</div>
      </div>
    );
  }
}
